import * as React from 'react';

import { AUTHENTICATION_MODAL_MODES } from 'bundles/authentication-common/constants';
import { OrganizationSSO } from 'bundles/authentication/shared/components/authentication-modal/OrganizationSSO/OrganizationSSO';
import type { Props } from 'bundles/authentication/shared/components/authentication-modal/OrganizationSSO/types';

const SignupComponent = (props: Props) => (
  <OrganizationSSO {...props} ssoMode={AUTHENTICATION_MODAL_MODES.ORGANIZATIONSIGNUP} />
);

export default SignupComponent;
